<div class="content-wrapper d-print-none">
  <div class="row">
    <div class="col-lg-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">External Hires</h4>

          <div class="input-group-append">
                      <button class="btn btn-sm btn-primary" type="button" (click)="downloadExcel()">Download</button>
                  </div>

          <div class="table-responsive pt-3">
            <nz-table #ManPowerTable [nzData]="Requests" [nzPageSize]="50">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Start Date</th>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Function</th>
                  <th>Location</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let data of ManPowerTable.data; let i = index">
                  <td>{{ i + 1 }}</td>

                  <td>
                    {{ data.startDate | date: 'dd MMMM yyyy' }}
                  </td>

                  <td>{{ data.name }}</td>

                  <td>{{ data.role }}</td>

                  <td>{{ data.function }}</td>

                  <td>{{ data.location }}</td>

                  <td>
                    <button [ngClass]="getStatusColor(data.status)">
                      {{ data.status }}
                    </button>
                  </td>

                  <td>
                    <div class="dropdown">
                      <button
                        class="btn btn-primary dropdown-toggle"
                        type="button"
                        data-toggle="dropdown"
                      ></button>

                      <div class="dropdown-menu">
                        <a class="dropdown-item" (click)="open(data)">View  Details</a>
                        <div class="dropdown-divider"></div>

                       
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Context Menu -->
<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li nz-menu-item>1st menu item</li>
    <li nz-menu-item>2nd menu item</li>
    <li nz-menu-divider></li>
  </ul>
</nz-dropdown-menu>

<!-- DRAWER 1: NEW HIRE DETAILS -->
<nz-drawer
  [nzBodyStyle]="{ overflow: 'auto' }"
  [nzMaskClosable]="false"
  [nzWidth]="900"
  [nzVisible]="ViewManpowerRequestVisible"
  [nzFooter]="footerTpl"
  (nzOnClose)="close()"
>
  <div class="d-print-block drawer-content" id="detailSection">
    <div class="card">
      <div class="drawer-header">
        <img src="../../../assets/images/holcim_logo_color.svg" />
      </div>

      <div class="card-body">
        <h5> <b>PERSONAL INFORMATION</b></h5>
        <div class="drawer-row">
          <div class="col-6">
            <label><b>Name</b></label>
            <p>{{ UpdateRequest?.name }}</p>
          </div>
          <div class="col-6">
            <label><b>Email</b></label>
            <p>{{ UpdateRequest?.email }}</p>
          </div>
        </div>

        <div class="drawer-row">
          <div class="col-6">
            <label><b>Phone</b></label>
            <p>{{ UpdateRequest?.phone }}</p>
          </div>
          <div class="col-6">
            <label><b>Start Date</b></label>
            <p>{{ UpdateRequest?.startDate | date: 'dd MMMM yyyy' }}</p>
          </div>
        </div>

        <h5><b>ROLE INFORMATION</b></h5>
        <div class="drawer-row">
          <div class="col-6">
            <label><b>Role</b></label>
            <p>{{ UpdateRequest?.role }}</p>
          </div>
          <div class="col-6">
            <label><b>Function</b></label>
            <p>{{ UpdateRequest?.function }}</p>
          </div>
        </div>

        <div class="drawer-row">
          <div class="col-6">
            <label><b>Location</b></label>
            <p>{{ UpdateRequest?.location }}</p>
          </div>
          <div class="col-6">
            <label><b>Status</b></label>
            <p>{{ UpdateRequest?.status }}</p>
          </div>
        </div>

        <h5><b>MANAGEMENT INFORMATION</b></h5>
        <div class="drawer-row">
          <div class="col-6">
            <label><b>Line Manager</b></label>
            <p>{{ UpdateRequest?.lineManager }}</p>
          </div>
          <div class="col-6">
            <label><b>HRBP</b></label>
            <p>{{ UpdateRequest?.hrbp }}</p>
          </div>
        </div>

        <div class="drawer-row">
          <div class="col-12">
            <label><b>Comment</b></label>
            <p>{{ UpdateRequest?.notes }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #footerTpl>
    <div class="drawer-footer">
      <button class="btn btn-primary" (click)="print(UpdateRequest?.name, 'detailSection')">
        Print
      </button>
      <button class="btn btn-light" (click)="close()">Close</button>
    </div>
  </ng-template>
</nz-drawer>



